class Tween {
    /**
     * 
     * @param {BaseKeyframeTween} begin 
     * @param {BaseKeyframeTween} goal 
     */
    constructor(begin, goal) {
        this.keyframeBegin = begin;
        this.keyframeGoal = goal;
    }
}

class TweenInterval extends Tween {
    /**
     *
     * @param {BaseKeyframeTween} begin
     * @param {BaseKeyframeTween} goal
     * @param {number} time
     * @param {number} offset
     */
    constructor(begin, goal, time, offset) {
        super(begin, goal);

        this.offset = offset;
        this.time = time;
    }
}


class BaseKeyframeTween {
    constructor() { }
    fromSlide() { throw new Error("Must be implemented in inheriting class."); }
    tweenTo() { throw new Error("Must be implemented in inheriting class."); }
}

export { Tween, TweenInterval, BaseKeyframeTween };